import { useState, createContext, useContext } from "react";

const AuthContext = createContext();

// Local dev bypass: Supabase auth removed from the backend, so there's
// nothing to authenticate against. Every session is a fixed local user.
const LOCAL_USER = { id: "local-dev-user", email: "local@designbench.dev" };
const LOCAL_TOKEN = "local-dev-token";

export function AuthProvider({ children }) {
  const [user] = useState(LOCAL_USER);
  const [token] = useState(LOCAL_TOKEN);
  const [loading] = useState(false);

  const login = async () => ({ user: LOCAL_USER, token: LOCAL_TOKEN });
  const logout = async () => {};

  const value = {
    user,
    loading,
    login,
    logout,
    token,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
